export const lightGray = '#E3E3E3';